'use strict';
// TODO: move to app/shared/ directory

const TypeUtil = {
    parseBoolean: function(input, defaultVal=false, warn=true) {
        if (!input) {
            return false;
        }

        if (typeof input === 'boolean') {
            return input;
        }

        if (typeof input === 'string') {
            const inputToLower = input.toLowerCase();

            if (inputToLower === 'false' || inputToLower === '0') {
                return false;
            }

            if (inputToLower === 'true' || inputToLower === '1') {
                return true;
            }
        }

        if (warn) console.warn(`parseBoolean: Unable to parse "${input}". Returning ${defaultVal}.`);
        return defaultVal;
    },

    /* parseCorrect: parse activiy analytics answer 'correct' property.
        - applies to MCQ, Match & Category answers
        - will return true, false or null
            - true = correct
            - false = incorrect
            - null = neutral (answer corresponds with some opinion-based question/category OR default unable-to-parse value)
    */
    parseCorrect: function(input, defaultVal=null, warn=true) {
        if (input === undefined || input === null) {
            return null;
        }

        const correctBool = this.parseBoolean(input, 'UNPARSED', false);

        if (correctBool !== 'UNPARSED') {
            return correctBool;
        }

        if (typeof input === 'string') {
            const inputToLower = input.toLowerCase();

            if (inputToLower === 'correct') {
                return true;
            }

            if (inputToLower === 'incorrect') {
                return false;
            }

            if (inputToLower  === 'neutral') {
                return null;
            }
        }

        if (warn) console.warn(`parseCorrect: Unable to parse "${input}". Returning ${defaultVal}.`);
        return defaultVal;
    }

};

module.exports = TypeUtil;